import React, { useState } from 'react';
import { ItemStats } from '../components/items/ItemStats';
import { ItemList } from '../components/items/ItemList';
import { ItemFilters } from '../types/item';

export const Items: React.FC = () => {
  const [filters, setFilters] = useState<ItemFilters>({
    page: 1,
    limit: 10,
    isActive: undefined,
    search: ''
  });

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters(prev => ({
      ...prev,
      search: e.target.value,
      page: 1
    }));
  };

  const handleActiveFilterChange = (value: string) => {
    setFilters(prev => ({
      ...prev,
      isActive: value === 'all' ? undefined : value === 'active',
      page: 1
    }));
  };

  const getActiveFilterValue = () => {
    if (filters.isActive === undefined) return 'all';
    return filters.isActive ? 'active' : 'inactive';
  };

  const inputStyle: React.CSSProperties = {
    padding: '9px 12px', background: '#f4efe2',
    border: '1px solid rgba(92,78,51,0.25)', borderRadius: 4,
    fontFamily: "'Inter', sans-serif", fontSize: 12, color: '#5b5a52',
    outline: 'none', colorScheme: 'light' as any,
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Page Header */}
      <div style={{ paddingBottom: 20, borderBottom: '1px solid rgba(92,78,51,0.15)' }}>
        <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 10, fontWeight: 400, letterSpacing: '0.4em', textTransform: 'uppercase', color: '#8a8778', marginBottom: 8 }}>
          Inventory
        </div>
        <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 36, fontWeight: 300, color: '#1c2033', lineHeight: 1 }}>
          Items
        </div>
        <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, fontWeight: 300, color: '#8a8778', marginTop: 8 }}>
          Manage your products and inventory
        </div>
      </div>

      <ItemStats />

      {/* Filters */}
      <div style={{ background: '#ffffff', border: '1px solid rgba(92,78,51,0.15)', borderRadius: 6, padding: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
          <div style={{ position: 'relative', flex: 1, minWidth: 200 }}>
            <input
              type="text"
              placeholder="Search items..."
              value={filters.search || ''}
              onChange={handleSearchChange}
              style={{ ...inputStyle, width: '100%', paddingLeft: 36, boxSizing: 'border-box' }}
              onFocus={e => { (e.target as HTMLInputElement).style.borderColor = 'rgba(217,119,6,0.35)'; }}
              onBlur={e => { (e.target as HTMLInputElement).style.borderColor = 'rgba(92,78,51,0.25)'; }}
            />
            <div style={{ position: 'absolute', top: '50%', left: 12, transform: 'translateY(-50%)', pointerEvents: 'none' }}>
              <svg width="16" height="16" fill="none" stroke="#8a8778" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div>
          <select
            value={getActiveFilterValue()}
            onChange={(e) => handleActiveFilterChange(e.target.value)}
            style={{ ...inputStyle, cursor: 'pointer' }}
          >
            <option value="all">All Items</option>
            <option value="active">Active Items</option>
            <option value="inactive">Inactive Items</option>
          </select>
        </div>
      </div>

      <ItemList filters={filters} />
    </div>
  );
};